import { Input } from 'antd';
import { WrapperTextArea } from './style';
import Label from '../style';
const { TextArea } = Input;

export default ({
  onChange,
  label,
  value,
  status,
  name,
  placeholder,
  id,
  autoSize = false,
  ...rest
}) => {
  return (
    <WrapperTextArea {...rest}>
      <div>
        <Label title={label} />
      </div>
      <TextArea
        autoSize={autoSize}
        showCount
        // maxLength={100}
        onChange={onChange}
        value={value}
        name={name}
        id={id}
        placeholder={placeholder}
        status={status ?? ''}
      />
    </WrapperTextArea>
  );
};
